import type { FC } from 'react'
import {
	Box,
	ColumnLayout,
	Container,
	Header
} from '@cloudscape-design/components'
import type { MongoDBApplicationContext } from '../../../types/mongodb'
import { getMongoDBTagEntries } from '../../../helper/mongodbApplicationDetails'

interface ApplicationDetailsProps {
	details?: MongoDBApplicationContext
}

const ApplicationDetails: FC<ApplicationDetailsProps> = ({ details }) => {
	const tags = getMongoDBTagEntries(details ?? {})

	return (
		<Container header={<Header variant="h2">Tag Details</Header>}>
			{tags.length ? (
				<ColumnLayout columns={2} variant="text-grid">
					{tags.map(({ key, label, value }) => (
						<div key={key}>
							<Box variant="awsui-key-label">{label}</Box>
							<Box>{value}</Box>
						</div>
					))}
				</ColumnLayout>
			) : (
				<Box color="text-body-secondary">-</Box>
			)}
		</Container>
	)
}

export default ApplicationDetails
